module.exports = __webpack_public_path__ + "img/house-heart.698a5da2.svg";